import React from 'react';
import { Modal, Row, Col, Image } from 'react-bootstrap';
import '../stylesheets/ModalOp.css';
class ErrorModal extends React.Component {

  handleClose = () => this.props.closeError();
  render() {

    var pr = this.props.errorDesc;

    var useImage = (function () {
      switch (true) {
        case (/^[1]+:[0-9]+$/).test(pr):
          return 'trouble';
        case (/^[2]+:[0-9]+$/).test(pr):
          return 'declined';
        case (/^[3-5]+:[0-9]+$/).test(pr):
          return 'aborted';
        default:
          return 'error';
      }
    })();

    return (
      <Modal id = "errorModel" show={this.props.show} dialogClassName={this.props.isMobile ? null : 'fit-content'} onHide={this.handleClose} animation={false}>
        <Modal.Header closeButton>
          <Row>
            <Col xs={5} sm={4} md={4} className="my-fit-test">
              <Image
                alt=""
                id="Error"
                // src={/^[0-9]+:[0-9]+$/.test(this.props.errorDesc) ? `${process.env.PUBLIC_URL}/assets/images/declined.png`:`${process.env.PUBLIC_URL}/assets/images/error.png`}
                src={`${process.env.PUBLIC_URL}/assets/images/${useImage}.png`}
                rounded />
            </Col>
            <Col className="center-error-text">
              {/* <h5>{/^[0-9]+:[0-9]+$/.test(this.props.errorDesc) ? this.props.translate[this.props.errorDesc] : this.props.errorDesc }</h5> */}
              <h5>{this.props.translate[this.props.errorDesc] ? this.props.translate[this.props.errorDesc] : this.props.translate['SomethingWrong']}</h5>
            </Col>
          </Row>
          {/* <img
              alt=""
              id="Error"
              src={/^[0-9]+:[0-9]+$/.test(this.props.errorDesc) ? `${process.env.PUBLIC_URL}/assets/images/declined.png`:`${process.env.PUBLIC_URL}/assets/images/error.png`} />
          <h5 className="center-error-text">{/^[0-9]+:[0-9]+$/.test(this.props.errorDesc) ? this.props.translate[this.props.errorDesc] : this.props.errorDesc }</h5> */}
        </Modal.Header>
      </Modal>
    );
  }
}
export default ErrorModal;